require('./blocks/textpage.less');
require('./blocks/claim/claim.less');
require('./blocks/claim/claim.js');
require('./blocks/form/form.less');



// WEBPACK FOOTER //
// ./claim.js